<template>
  <div class="index">
    <el-page-header @back="goBack" title content="员工列表"></el-page-header>
    <div class="staff">
      <div class="staff_header">
        <div class="staff_search">
          <el-input v-model="nameormobile" style="margin-right:10px" placeholder="请输入员工姓名或电话"></el-input>
          <el-select v-model="isOnLinePara" style="margin-right:10px" placeholder="请选择">
            <el-option
              v-for="(item,i) in onlineOpt"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </div>
        <div>
          <el-button type="primary" @click="toImport()">批量导入</el-button>
          <el-button type="primary" @click="toEdit()">新建</el-button>
        </div>
      </div>
      <div class="staff_list">
        <el-table :data="data" style="width: 100%">
          <el-table-column prop="Name" label="姓名"></el-table-column>
          <el-table-column prop="Mobile" label="电话"></el-table-column>
          <el-table-column prop="Dept" label="部门"></el-table-column>
          <el-table-column prop="Job" label="职位"></el-table-column>
          <el-table-column prop="IsOnline" label="状态">
            <template slot-scope="scope">
              <span>{{scope.row.IsOnline | getStatus}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Id" label="操作">
            <template slot-scope="scope">
              <el-link type="primary" @click="toEdit(scope.row.Id)">编辑</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="pageIndex"
            :page-size="pageSize"
            :total="total"
            @current-change="pageChange"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      nameormobile: "",
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      isOnLinePara: null,
      onlineOpt: [
        {
          label: "在职",
          value: 1
        },
        {
          label: "离职",
          value: 0
        }
      ],
      data: []
    };
  },
  mounted: function() {
    this.getStaffList();
  },
  methods: {
    getStaffList: function() {
      this.$api
        .get("/xsss/v1/staff", {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          nameormobile: this.nameormobile,
          isOnLinePara: this.isOnLinePara
        })
        .then(res => {
          this.data = res.data.data;
          this.pageIndex = res.data.pageIndex;
          this.pageSize = res.data.pageSize;
          this.total = res.data.count;
        });
    },
    search: function() {
      this.pageIndex = 1;
      this.getStaffList();
    },
    pageChange: function(page) {
      this.pageIndex = page;
      this.getStaffList();
    },
    resetSearch: function() {
      this.nameormobile = "";
      this.isOnLinePara = null;
      this.pageIndex = 1;
      this.getStaffList();
    },
    toEdit: function(id) {
      id ? null : (id = "");
      this.$router.push({
        path: "/staff/edit",
        query: {
          id
        }
      });
    },
    toImport: function() {
      this.$router.push({
        path: "/staff/import"
      });
    },
    goBack: function() {
      return false;
    }
  },
  filters: {
    getStatus: function(status) {
      return status == 0 ? "离职" : "在职";
    }
  }
};
</script>

<style scoped>
@import url("./index.css");
</style>